<template>
 <div class="text-center">
    <v-dialog v-model="dialog" :width="options.width" @keydown.esc="cancel">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          {{ title }}
        </v-card-title>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <div class="mt-3">{{ message }}</div>
          <div v-if="options.textField">
            <v-text-field :label="options.textField" v-model="dialogInput"></v-text-field>
          </div>
          <div v-if="options.file">
             <v-file-input
          v-model="uploadFile"
          ref="file"
          :label="options.file"
          :accept="options.fileExtension"
          dense
        ></v-file-input>
          </div>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="options.confirmation" color="primary" outlined @click="cancel"> Cancel </v-btn>
          <v-btn color="primary" depressed @click.native="ok"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Dialog',

  data: () => ({
    dialog: false,
    dialogInput:'',
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      textField:null,
      file:null,
      fileExtension:null,
      color: 'primary',
      width: 500,
      zIndex: 200,
      confirmation:true,
    },
    uploadFile:null,
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    ok() {
      if (this.options.textField) {
        this.resolve(this.dialogInput);
      }
      else
      if (this.options.file) {
        this.resolve(this.uploadFile);
      }
      else
        this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    },
  },
};
</script>
